import { Injectable } from '@angular/core';

@Injectable()
export class OrderingService {
  order(
    list: any[],
    propertyName: string,
    direction: 'asc' | 'desc' = 'asc',
    caseSensitive: boolean = true
  ): any[] {
    if (!list) {
      return [];
    }

    if (!propertyName || propertyName.trim() === '') {
      return list;
    }

    const genericOptions: any[] = list.filter((x) => x?.keepOnTop) || [];
    list = list.filter((x) => !x?.keepOnTop);

    // asc
    if (direction === 'asc') {
      return [
        ...genericOptions,
        ...Array.from(list).sort((item1: any, item2: any) => {
          return this.sortByComparator(
            this.getProperty(item1, propertyName),
            this.getProperty(item2, propertyName),
            caseSensitive
          );
        }),
      ];
    } else {
      // desc
      return [
        ...genericOptions,
        ...Array.from(list).sort((item1: any, item2: any) => {
          return this.sortByComparator(
            this.getProperty(item2, propertyName),
            this.getProperty(item1, propertyName),
            caseSensitive
          );
        }),
      ];
    }
  }

  sortByComparator(a: any, b: any, caseSensitive: boolean): number {
    if ((a === null || a === undefined) && (b === null || b === undefined)) {
      return null;
    }

    if (
      isNaN(parseFloat(a)) ||
      !isFinite(a) ||
      isNaN(parseFloat(b)) ||
      !isFinite(b)
    ) {
      if (caseSensitive) {
        if (a < b) {
          return -1;
        }
        if (a > b) {
          return 1;
        }
      } else {
        if (a.toLocaleLowerCase() < b.toLocaleLowerCase()) {
          return -1;
        }
        if (a.toLocaleLowerCase() > b.toLocaleLowerCase()) {
          return 1;
        }
      }
    } else {
      // Parse number strings as numbers to compare properly
      if (parseFloat(a) < parseFloat(b)) {
        return -1;
      }
      if (parseFloat(a) > parseFloat(b)) {
        return 1;
      }
    }

    // equal each other
    return 0;
  }

  getProperty(obj: any, path: string): any {
    if (!path || !obj) {
      return null;
    }

    return path
      .split('.')
      .reduce(
        (result, prop) => (result == null ? undefined : result[prop]),
        obj
      );
  }
}
